import SolidCircleIcon from 'LuxKit/Icons/solid/SolidCircleIcon'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

const PulsingIndicator = styled(SolidCircleIcon)`
  animation: ${pulse} 1s ease-in-out infinite;
`

export default function BusinessTravellerPendingApprovalsIndicator() {
  return <PulsingIndicator style={{ width: 6, height: 6, marginLeft: 4, marginBottom: 8 }} colour="warning" />
}
